import moment from "moment"
import {sortBy} from "lodash"

import {store} from "@irati/store"
import {UPDATE_ANALYSIS_FILTER, RESET_ANALYSIS_FILTERS} from "../actions/analysis"


const TIME_OPTIONS = [
  {label: "insights.filters.time.values.allTime", value: null},
  {label: "insights.filters.time.values.lastMonth", value: moment().subtract(1, "month").format()},
  {label: "insights.filters.time.values.lastThreeMonths", value: moment().subtract(3, "months").format()},
  {label: "insights.filters.time.values.lastSixMonths", value: moment().subtract(6, "months").format()}
]


const _formatDriverOptions = () => {
  const drivers = store.getState().insights.drivers

  /** @todo n.b. not using formatDriverName here bc this redux stuff will be removed soon */
  let driverOptions = drivers.map((driver) => ({label: `${driver.contentId}.name`, value: driver.id}))
  driverOptions = sortBy(driverOptions, "label")
  driverOptions.unshift({label: "insights.filters.driver.values.allDrivers", value: null})

  return driverOptions
}


const _formatTeamOptions = () => {
  const teams = store.getState().teams

  let teamOptions = teams.list.map((team) => ({label: team.public_name, value: team.uuid}))
  teamOptions = sortBy(teamOptions, "label")
  teamOptions.unshift({label: "insights.filters.team.values.allTeams", value: null})

  return teamOptions
}


const _getDefaultState = () => {
  const timeOptions = TIME_OPTIONS
  const driverOptions = _formatDriverOptions()
  const teamOptions = _formatTeamOptions()

  return {
    timeOptions,
    driverOptions,
    teamOptions,

    timeValue: timeOptions[2],
    driverValue: driverOptions[0],
    teamValue: teamOptions[0]
  }
}


const AnalysisReducer = (state = {}, action) => {
  const {type, property, value} = action

  switch (type) {
    case RESET_ANALYSIS_FILTERS:
      return {
        ..._getDefaultState()
      }
    case UPDATE_ANALYSIS_FILTER:
      return {
        ...state,
        [property]: value
      }
    default:
      return state
  }
}

export default AnalysisReducer
